import { CommittedIcon } from '@/assets/icons/investment-status/committed';
import { RejectedIcon } from '@/assets/icons/investment-status/rejected';
import { TerminatedIcon } from '@/assets/icons/investment-status/treminated';
import { Tooltip } from '@/components/basicComponents/tooltip';
import { currencyFormatterNoCents } from '@/shared/utils/currency';
import { format } from 'date-fns';
import styled from 'styled-components';
import { ExtendedBulkAllocation } from '../../types';

type PrevStatusType = {
  data: ExtendedBulkAllocation['preAllocationStatus'];
  amount: number;
};

const PrevStatus = ({ data, amount }: PrevStatusType) => {
  const windowWidth = window.innerWidth;

  const getIcon = () => {
    if (data.alreadyCommitted) {
      return <CommittedIcon />;
    } else if (data.internalReviewRejections) {
      return <RejectedIcon />;
    } else {
      return <TerminatedIcon />;
    }
  };

  const getTooltipContent = () => {
    if (data.alreadyCommitted) {
      return (
        <TooltipContent>
          <TooltipRow>Committed: {amount ? currencyFormatterNoCents.format(amount) : '$0'}</TooltipRow>
          {data.committedAt && <TooltipRow>{format(new Date(data.committedAt), 'LLL d, yyyy').toUpperCase()}</TooltipRow>}{' '}
        </TooltipContent>
      );
    } else if (data.internalReviewRejections) {
      return (
        <TooltipContent>
          <TooltipRow>Internal Review Rejected</TooltipRow>
          {data.internalReviewRejectionAt && <TooltipRow>{format(new Date(data.internalReviewRejectionAt), 'LLL d, yyyy').toUpperCase()}</TooltipRow>}
        </TooltipContent>
      );
    } else if (data.terminated) {
      return (
        <TooltipContent>
          <TooltipRow>Terminated</TooltipRow>
          {data.terminatedAt && <TooltipRow>{format(new Date(data.terminatedAt), 'LLL d, yyyy').toUpperCase()}</TooltipRow>}{' '}
        </TooltipContent>
      );
    } else {
      return <></>;
    }
  };

  return data ? <PrevStatusWrap>{getTooltipContent() ? <Tooltip title={getTooltipContent()}>{getIcon()}</Tooltip> : <></>}</PrevStatusWrap> : <></>;
};

const TooltipRow = styled.div`
  display: flex;
`;

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const PrevStatusWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  position: relative;
  top: 3px;
`;

export default PrevStatus;
